export const root = "rbyc2gk";
export const item = "i1kjk55a";
export const compactBadges = "cl0t2ky";
export const overlappingBadges = "oa73tae";

require("./style.linaria.module.css!=!../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");